<template>
  <div>
    <a-row>
      <!-- <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <div style="text-align: left">
          <h1 style="font-size: 40px; font-weight: bolder">
            Find drug compounds
          </h1>
        </div>
      </a-col> -->
      <!-- <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <a-alert type="success">
          <span slot="message" style="font-size: 18px"
            >In partnership with the ConnectivityMap project, we have conducted
            targeted drug analysis for all genes with effective perturbations,
            retaining the top 50 drugs that showed similar perturbations or
            reversed perturbations. However, it is recommended to prioritize
            small-molecule compounds with scores greater than 95 for further
            experimental validation.</span
          >
        </a-alert>
      </a-col> -->
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <!-- <druglist /> -->
        <div class="card-container">
          <a-tabs type="card">
            <a-tab-pane key="1" tab="List of gene inhibitors">
              <druglist />
            </a-tab-pane>
            <!-- <a-tab-pane key="2" tab="Browse by genes">
              <genelist />
            </a-tab-pane> -->
          </a-tabs>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
// import axios from "axios";
// import XEUtils from "xe-utils";
import druglist from "../components/drugs/00drugList.vue";
// import genelist from "../components/drugs/gene_table.vue";

export default {
  components: { druglist },
  methods: {},
  watch: {},
  created() {},
  data() {
    return {};
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 20px;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}
</style>
